export const ALTO_CORE_EVENT_NAMES = {
  altoCoreLoginWithMagicLink: 'AltoCore: Login via Magic Link',
  altoCoreHorPageVisited: 'AltoCore: Request Details page viewed',
  altoCoreDataAnalyticsPageVisited: 'AltoCore: Data Analytics page viewed',
  altoCoreHousingRequestsPageVisited: 'AltoCore: Housing Requests page viewed',
  altoCorePropertyPageVisited: 'AltoCore: Property page viewed',
  altoCoreCreatePropertyPageVisited: 'AltoCore: Create Property page viewed',
  altoCorePropertyPortfolioPageVisited:
    'AltoCore: Property Portfolio page viewed',

  altoCoreAddPropertyModalOpened: 'AltoCore: Option Shortlisted (form view)',
  altoCorePropertySavedToShortlist: 'AltoCore: Saved to Shortlist',
  altoCorePropertyInShortlistUpdated: 'AltoCore: Edit Shortlisted property',

  altoCoreOptionsSubmitted: 'AltoCore: Options Submitted',

  altoCoreAvailabilityConfirmed: 'AltoCore: Availability Confirmed',
  altoCoreAvailabilityDeclined: 'AltoCore: Availability Declined',

  altoCoreHorDeclined: 'AltoCore: Request Declined',

  altoCoreDataAnalyticsDeclineReasonExported:
    'AltoCore: Decline Reasons report exported',
  altoCoreDataAnalyticsDeclineReasonClientViewed:
    'AltoCore: Decline Reasons: declined by Altovita',
  altoCoreDataAnalyticsDeclineReasonBookingViewed:
    'AltoCore: Decline Reasons: declined by Client',
  altoCoreArrivalGuideDownloaded: 'Arrival guide downloaded',
  altoCoreArrivalGuideEmailSent: 'Arrival guide email sent',
}
